const countryCode = {
  type: 'Matrix',
  key: 'countryCode',
  value: 'US'
};

export default countryCode;



// WEBPACK FOOTER //
// ./app/models/countryCodeIntegration.js